<template>
  <div class="rotation-info app-region blank-t-v blank-b-v blank-l-h blank-r-h" v-if="!isScan">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" >
      <a-form-model-item label="轮播名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入轮播名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="轮播图片" prop="avatar">
        <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange">
          <dy-image :src="form.avatar" v-if="form.avatar" preview></dy-image>
          <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="跳转类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">社区应用</a-radio>
          <a-radio :value="2">外部链接</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <!-- <a-form-model-item label="展示区域" prop="a_type">
        <a-radio-group v-model="form.a_type">
          <a-radio :value="1">业主端</a-radio>
          <a-radio :value="2">物业端</a-radio>
        </a-radio-group>
      </a-form-model-item> -->
			
      <template v-if="form.type === 1">
        <a-form-model-item label="选择应用" prop="modelType">
          <a-select v-model="form.modelType" placeholder="请选择应用">
            <a-select-option :value="1">物业公告</a-select-option>
            <a-select-option :value="2">活动报名</a-select-option>
            <a-select-option :value="3">问卷调查</a-select-option>
            <a-select-option :value="4">邻里话题</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选择内容" prop="modelId">
          <a-select v-model="form.modelId" placeholder="请选择内容">
            <a-select-option :value="value.id" v-for="value in modelOptions" :key="value.id">{{value.title}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </template>
			
      <a-form-model-item v-if="form.type === 2" label="外部跳转链接" prop="link">
        <a-input v-model="form.link" placeholder="请输入外部跳转链接"  allow-clear></a-input>
      </a-form-model-item>
			
      <a-form-model-item label="发布社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择发布社区" :disabled="!isPlatformRole">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
			
      <a-form-model-item label="启用状态" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>
			
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol" v-if="!isScan">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
		
  </div>
	
	
  <div class="rotation-info" v-else>
    <a-descriptions bordered v-viewer>
      <a-descriptions-item label="轮播名称">{{form.name}}</a-descriptions-item>
      <a-descriptions-item label="轮播图片">
        <dy-image :src="form.avatar"></dy-image>
      </a-descriptions-item>
      <a-descriptions-item label="跳转类型">{{form.type === 1 ? '社区应用' : '外部链接'}}</a-descriptions-item>
      <template v-if="form.type === 1">
        <a-descriptions-item label="选择应用">{{form.type === 1 ? '物业公告' : (form.type === 2 ? '活动报名' : (form.type === 3 ? '问卷调查' : '邻里话题'))}}</a-descriptions-item>
        <a-descriptions-item label="选择内容">{{modelOptions.filter(val => form.modelId === val.id).map(val => val.title).join('、')}}</a-descriptions-item>
      </template>
      <a-descriptions-item label="外部跳转链接" v-if="form.type === 2">{{form.link}}</a-descriptions-item>
      <a-descriptions-item label="发布社区">{{communityOptions.filter(val => form.community.indexOf(val.id) > -1).map(val => val.name).join('、')}}</a-descriptions-item>
      <a-descriptions-item label="启用状态">{{form.status ? '启用' : '禁用'}}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
  import RotationService from "@/io/rotation.js";
  import CommunityService from '@/io/community.js';
  import PropertyNoticeService from '@/io/property_notice.js';
  import ActivityService from '@/io/activity.js';
  import QuestionnaireService from '@/io/questionnaire.js';
  import TopicService from '@/io/topic.js';

  export default {
    props: {
      isScan: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default() {
          return this.$route.params.id * 1;
        }
      }
    },
    data() {
      return {
        avatar: {
          loading: false,
        },
        communityOptions: [],
        modelOptions: [],
        form: {
          name: null,
          avatar: null,
          type: null,
          modelType: [],
          modelId: [],
          link: null,
          community: [],
          status: null,
        },
        rules: {
          name: [
            {
              required: true,
              message: "请输入轮播名称",
            },
          ],
          avatar: [
            {
              required: true,
              message: "请上传轮播图片",
            },
          ],
          type: [
            {
              required: true,
              message: '请选择跳转类型'
            },
          ],
          modelType: [
            {
              required: true,
              message: "请选择应用",
            },
          ],
          modelId: [
            {
              required: true,
              message: "请选择应用内容",
            },
          ],
          link: [
            {
              required: true,
              message: '请输入外部链接'
            },
          ],
          community: [
            {
              required: true,
              message: "请填写发布社区",
            },
          ],
          status:[
            {
              required: true,
              message: '请选择启用状态'
            },
          ],
        },
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initCommunity().then(() => {
            this.initPage();
          });
        },
        immediate: true,
      },
      'form.modelType': {
        handler(newValue, oldValue) {
          if (newValue === 1) {
            PropertyNoticeService.list().then(res => {
              this.modelOptions = res;
            }).catch(err => {});
          } else if(newValue === 2) {
            ActivityService.list().then(res => {
              this.modelOptions = res;
            }).catch(err => {});
          } else if (newValue === 3) {
            QuestionnaireService.list().then(res => {
              this.modelOptions = res;
            }).catch(err => {});
          } else if (newValue === 4) {
            TopicService.list().then(res => {
              this.modelOptions = res.map(val => {
                val.title = val.content;
                return val;
              });
            }).catch(err => {});
          }
        },
        immediate: true
      }
    },
    methods: {
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
        if (this.id) {
          RotationService.info(this.id).then(res => {
            this.form.name = res.title;
            this.form.avatar = res.banner;
            this.form.type = res.jump_way;
            if (this.form.type === 1) {
              this.form.modelType = res.model_type;
              this.form.modelId = res.model_id;
            } else {
              this.form.link = res.link;
            }
            this.form.status = res.enable;
            this.form.community = res.community.map(val => val.community_id);
          });
        }
      },
      initCommunity() {
        return CommunityService.listPage().then((res) => {
          this.communityOptions = res;
        }).catch((err) => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          if (status === 'done') {
            this.avatar.loading = false;
            this.form.avatar = info.file.response.media;
          } else {
            this.avatar.loading = true;
          }
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            RotationService.edit(
              this.id,
              this.form.name,
              this.form.avatar,
              this.form.type,
              this.form.type === 1 ? null : this.form.link,
              this.form.type === 1 ? this.form.modelType : null,
              this.form.type === 1 ? this.form.modelId : null,
              this.form.type === 1 ? this.modelOptions.filter(val => val.id === this.form.modelId)[0].title : null,
              this.form.community,
              this.form.status,
              1
            ).then((res) => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch((err) => {});
          } else {
            RotationService.add(
              this.form.name,
              this.form.avatar,
              this.form.type,
              this.form.type === 1 ? null : this.form.link,
              this.form.type === 1 ? this.form.modelType : null,
              this.form.type === 1 ? this.form.modelId : null,
              this.form.type === 1 ? this.modelOptions.filter(val => val.id === this.form.modelId)[0].title : null,
              this.form.community,
              this.form.status,
              1
            ).then((res) => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch((err) => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          name: 'RotationManage'
        });
      },
    },
  };
</script>

<style lang="less" scoped>

</style>